import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import * as React from "react";
import {useState} from "react";
import {GuideIcon} from "../../../../../modules/icons/guide";
import "./createadstation.scss"
import Dropdown from "../../../../../ui/dropdown/dropdown";
import AutoComplete from "../../../../../ui/autocomplete/autocomplete";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import {autoCompleteItem} from "../../../../../modals/types/autocomplete";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import PostSlider from "../../../../../ui/slider/postslider/postslider";
import {choosedFile} from "../../../../../ui/dropzone/multiselect/multielectdropzone";
import Alert from "../../../../../ui/alert/alert";
import Button from "../../../../../core/button/button";
import CopyIcon from "../../../../../modules/icons/copy";
import {useNavigate} from "react-router-dom";

const CreateAdStation = () => {
    const mediaTypeDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"},
    ];
    const stationPlaceAutoCompleteItems: DropDownItem[] = [
        {label: "تصویری"}, {label: "متنی"}, {label: "میان مطلب تصویری تکرارشونده"}, {label: "نوتیفیکیشن شناور"}, {label: "ثابت پایینی"}, {label: "میان مطلب متنی"}
    ];
    const devicesDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"},
    ];
    const desktopTitleDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"},
    ];
    const mobileTitleDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"},
    ];
    const mediaTitleAutoCompleteItems: autoCompleteItem[] = [
        {title: "آیتم 1"}, {title: "آیتم 2"}, {title: "آیتم 3"}, {title: "آیتم 4"}
    ];
    const [value, setValue] = useState<DropDownItem>({label: ""});
    const sliderImages: choosedFile[] = [
        {url: require("../../../../../assets/images/photos/StationImage.png")},
        {url: require("../../../../../assets/images/photos/StationImage.png")},
        {url: require("../../../../../assets/images/photos/StationImage.png")},
    ]
    const renderStationType = (): JSX.Element => {
        if (value.label === 'تصویری' || value.label === 'متنی' || value.label === 'میان مطلب تصویری تکرارشونده') {
            return (
                <div>
                    <div className="Create-Ad-Station-Header">
                        <div className="d-flex align-items-center mb-1 Create-Ad-Station-Header-Title">
                            <DotIndicator/>
                            <span>تنظیمات جایگاه</span>
                            <GuideIcon/>
                        </div>
                        <p className="Create-Ad-Station-Header-Subtitle">جزییات نمایش جایگاه انتخابی در وبسایت خود را
                            مشخص نمایید. </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">تعداد سطر در دسکتاپ</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">تعداد ستون در دسکتاپ</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">تعداد سطر در موبایل</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">تعداد ستون در موبایل</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">عنوان دسکتاپ</h6>
                            <Dropdown items={desktopTitleDropDownItems}
                                      placeHolder="مثال: از جهان وب"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">عنوان موبایل</h6>
                            <Dropdown items={mobileTitleDropDownItems}
                                      placeHolder="مثال: مطالب پیشنهادی"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">رنگ پس زمینه عنوان جایگاه</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">رنگ متن عنوان جایگاه</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">رنگ حاشیه پایین Header جایگاه</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: ۲"/>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-8">
                            <Alert type={"Info"}>
                                برای استفاده از سیستم همسان ابتدا باید اسکریپت Teejaar را در قسمت head سایت خود قرار
                                دهید.
                                بعد از قرار دادن اسکریپت بالا در سایت خود، باید کد HTML مربوط به هر جایگاه را در سایت‌
                                خود در مکان مناسب قرار دهید.
                                <Button type={"secondary"} action={() => {
                                }} responsive={false}>
                                    <CopyIcon/>
                                    کپی کنید
                                </Button>
                            </Alert>
                        </div>
                    </div>
                </div>
            )
        } else if (value.label === 'نوتیفیکیشن شناور' || value.label === 'ثابت پایینی') {
            return (
                <div>
                    <div className="Create-Ad-Station-Header">
                        <div className="d-flex align-items-center mb-1 Create-Ad-Station-Header-Title">
                            <DotIndicator/>
                            <span>تنظیمات جایگاه</span>
                            <GuideIcon/>
                        </div>
                        <p className="Create-Ad-Station-Header-Subtitle">جزییات نمایش جایگاه انتخابی در وبسایت خود را
                            مشخص نمایید. </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">جهت انیمیشن در سایت</h6>
                            <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال: راست"/>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-8">
                            <Alert type={"Info"}>
                                برای استفاده از سیستم همسان ابتدا باید اسکریپت Teejaar را در قسمت head سایت خود قرار
                                دهید.
                                بعد از قرار دادن اسکریپت بالا در سایت خود، باید کد HTML مربوط به هر جایگاه را در سایت‌
                                خود در مکان مناسب قرار دهید.
                                <Button type={"secondary"} action={() => {
                                }} responsive={false}>
                                    <CopyIcon/>
                                    کپی کنید
                                </Button>
                            </Alert>
                        </div>
                    </div>
                </div>
            )
        } else if (value.label === 'میان مطلب متنی') {
            return (
                <div>
                    <div className="Create-Ad-Station-Header">
                        <div className="d-flex align-items-center mb-1 Create-Ad-Station-Header-Title">
                            <DotIndicator/>
                            <span>تنظیمات جایگاه</span>
                            <GuideIcon/>
                        </div>
                        <p className="Create-Ad-Station-Header-Subtitle">جزییات نمایش جایگاه انتخابی در وبسایت خود را
                            مشخص نمایید. </p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">عنوان دسکتاپ</h6>
                            <Dropdown items={desktopTitleDropDownItems}
                                      placeHolder="مثال: از جهان وب"/>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 mb-2">
                            <h6 className="pt-4 pb-1">عنوان موبایل</h6>
                            <Dropdown items={mobileTitleDropDownItems}
                                      placeHolder="مثال: مطالب پیشنهادی"/>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-8">
                            <Alert type={"Info"}>
                                برای استفاده از سیستم همسان ابتدا باید اسکریپت Teejaar را در قسمت head سایت خود قرار
                                دهید.
                                بعد از قرار دادن اسکریپت بالا در سایت خود، باید کد HTML مربوط به هر جایگاه را در سایت‌
                                خود در مکان مناسب قرار دهید.
                                <Button type={"secondary"} action={() => {
                                }} responsive={false}>
                                    <CopyIcon/>
                                    کپی کنید
                                </Button>
                            </Alert>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <></>
        }
    }
    const navigate = useNavigate();
    return (
        <div className="Create-Ad-Station">
            <div className="Create-Ad-Station-Header">
                <div className="d-flex align-items-center mb-1 Create-Ad-Station-Header-Title">
                    <DotIndicator/>
                    <span>ساخت رسانه</span>
                    <GuideIcon/>
                </div>
                <p className="Create-Ad-Station-Header-Subtitle">اطلاعات رسانه خود را وارد نمایید.</p>
            </div>
            <div className="row pb-5">
                <div className="col-lg-6 col-md-6 col-12 mb-2">
                    <h6 className="pt-4 pb-1">عنوان رسانه</h6>
                    <input type="text" name="" id="" className="Campaign-Input" placeholder="انتخاب کنید"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-2">
                    <h6 className="pt-4 pb-1">نوع رسانه</h6>
                    <Dropdown items={mediaTypeDropDownItems}
                              placeHolder="انتخاب کنید ( سایت  یا تلگرام )"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-2">
                    <h6 className="pt-4 pb-1">آدرس URL رسانه</h6>
                    <input type="text" name="" id="" className="Campaign-Input" placeholder="teejar"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-2">
                    <h6 className="pt-4 pb-1">موضوع رسانه</h6>
                    <AutoComplete items={mediaTitleAutoCompleteItems} title={"مثال: هنر"}/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="row">
                <div className="col-lg-5 col-12 mb-2">
                    <div className="Create-Ad-Station-Header">
                        <div className="d-flex align-items-center mb-1 Create-Ad-Station-Header-Title">
                            <DotIndicator/>
                            <span>مشخصات جایگاه</span>
                            <GuideIcon/>
                        </div>
                        <p className="Create-Ad-Station-Header-Subtitle">نوع جایگاه تبلیغاتی وبسایت خود مشخص کنید.</p>
                    </div>
                    <div className="col-12 mb-2">
                        <h6 className="pt-4 pb-1">نوع جایگاه</h6>
                        <Dropdown value={value} setValue={setValue} items={stationPlaceAutoCompleteItems}
                                  placeHolder="مثال: انتهای مطلب"/>
                    </div>
                    <div className="col-12 mb-2">
                        <h6 className="pt-4 pb-1">دستگاه های نمایش دهنده</h6>
                        <Dropdown items={devicesDropDownItems}
                                  placeHolder="مثال: همه دستگاه‌ها"/>
                    </div>
                </div>
                <div className="col-1 mb-4"></div>
                <div className="col-lg-6 col-12 mb-2">
                    <div className="row">
                        <div className="col-lg-7 col-12 mb-3">
                            <PostSlider images={sliderImages}/>
                        </div>
                        <div className="col-lg-5 col-12 Slider-Desc mb-3">
                            این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند.
                            این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند.
                            چایگاه بنری است،
                        </div>
                    </div>
                </div>
            </div>
            <HorizontalDivider/>
            {renderStationType()}
            <div className="Action-Center">
                <Button type={"primary-light"} action={() => {
                    localStorage.setItem("createAdStation", "false");
                    navigate(0);
                }} responsive={true}>
                    انصراف
                </Button>
                <Button type={"primary"} action={() => {
                }} responsive={true}>
                    ساخت رسانه
                </Button>
            </div>
        </div>
    )
}

export default CreateAdStation